// extracted by mini-css-extract-plugin
export var button = "IpoNoticeModal-module--button--Ctgv5";
export var ipoModal = "IpoNoticeModal-module--ipoModal--yV+RJ";
export var modalContainer = "IpoNoticeModal-module--modalContainer--+rLvZ";
export var modalContent = "IpoNoticeModal-module--modal-content--RqX0b";
export var modalText = "IpoNoticeModal-module--modalText--Ywtbx";
export var primary = "#06004d";
export var secondary = "#4dafd7";